import type DisplayOrder from 'owa-people-types/lib/types/DisplayOrder';
import type BrowserWidthBucket from 'owa-layout/lib/store/schema/BrowserWidthBucket';

export enum Filter {
    All,
    // All People -> Contacts, Organisation
    HubPerson,
    Contact,
    Organization,
    // Groups -> Owned, Joined
    Group,
    OwnedGroup,
    JoinedGroup,
    // Lists -> Contact Lists, Distribution Lists
    List,
    PrivateDistributionList,
    PublicDistributionList,
}

// Do not change order. Value persisted in user config
export const enum Sorting {
    ByFirstName,
    ByLastName,
    ByStatus,
    ByHomeCity,
    ByWorkCity,
    ByCompany,
    ByLastChanged,
    ByRelevance,
    ByRecentlyAdded,
    ByName,
    ByDeletedDate,
}

export interface LayoutState {
    readonly leftPaneWidth: number;
    readonly listWidth: number;
    readonly isLeftNavVisible: boolean;
    readonly filter: Filter;
    readonly sorting: Sorting;
    readonly deletedItemsSorting: Sorting;
    readonly contactListsSorting: Sorting;
    readonly displayOrder: DisplayOrder;
    readonly browserWidthBucket: BrowserWidthBucket;
    readonly showHubList: boolean;
    readonly showRightPane: boolean;
    readonly showOverlayFolderPane: boolean;
    readonly isTablet: boolean;
    readonly isCAPIv3Enabled: boolean | undefined;
}
